import * as React from 'react';
import { useState, useEffect } from 'react';
import { Trans } from '@elevio/kb-kit/lib/components/trans';
import { useTranslation } from '@elevio/kb-kit/lib/hooks';
import * as Categories from '@elevio/kb-kit/lib/components/categories';
import PageLayout from '../components/layouts/Page';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import ChatButtons from '../components/ChatButtons';
import {
  MainSection,
  GridContainer,
  GridItem,
} from '../components/layouts/Main';
import CategoryCard from '../components/CategoryCard';
import SearchInput from '../components/searchInput/SearchInput';
const HomePage = () => {
  const { t } = useTranslation();
  const [article1, setArticle1] = useState(null);
  const [article2, setArticle2] = useState(null);
  const [article3, setArticle3] = useState(null);
  const [loading1, setLoading1] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [loading3, setLoading3] = useState(true);

  useEffect(() => {
    const headers = {
      'x-api-key': '025646f9117e4e0e1f51119cd3f886c6',
      'Authorization': `Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwcC5lbGV2LmlvIiwic3ViIjoiNjQ5MThlNWVkMDYxNCIsImV4cCI6MzMzNTk4MTc5MywiaWF0IjoxNzU5MTgxNzkzLCJqdGkiOiJlaTk4djgwNHVuam5tbnNrYjQ5NDFyZHFscGo0c25icSIsCiAgInVzZXJOYW1lIiA6ICJuYWFAc2F4by5jb20iLAogICJzY29wZSIgOiBbICJyZWFkOmFydGljbGUiIF0sCiAgInVzZXJJZCIgOiA2MjA3NiwKICAidHJhaXRzIiA6IHsKICAgICJncm91cHMiIDogWyBdLAogICAgInJlZ2lzdGVyZWRBdCIgOiAxNzEzNzgzMjUzMDAwLAogICAgImxhc3ROYW1lIiA6ICJUeW1jaHluYSIsCiAgICAiZmlyc3ROYW1lIiA6ICJOYXphcml5IgogIH0KfQ.T27Tdta62IenuB3RoPelsFxU46mNvPX7wr6XB398_KQ`
    };

    fetch('https://api.elev.io/v1/articles/162', { headers })
      .then(res => res.json())
      .then(data => {
        setArticle1(data.article);
        setLoading1(false);
      })
      .catch(err => console.error('Article 1 error:', err));

    fetch('https://api.elev.io/v1/articles/163', { headers })
      .then(res => res.json())
      .then(data => {
        setArticle2(data.article);
        setLoading2(false);
      })
      .catch(err => console.error('Article 2 error:', err));

    fetch('https://api.elev.io/v1/articles/164', { headers })
      .then(res => res.json())
      .then(data => {
        setArticle3(data.article);
        setLoading3(false);
      })
      .catch(err => console.error('Article 3 error:', err));

  }, []);

  const Spinner = () => (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '40px',
      minHeight: '100px'
    }}>
      <div className="spinner"></div>
      <style dangerouslySetInnerHTML={{
        __html: `
          .spinner {
            border: 3px solid #f3f3f3;
            border-top: 3px solid #8d8d8dff;
            border-radius: 50%;
            width: 40px;
            height: 40px;
            animation: spin-smooth 1s linear infinite;
          }
          
          @keyframes spin-smooth {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `
      }} />
    </div>
  );

  return (
    <PageLayout header={<Header />} footer={<Footer />}>
      <div className="banner">
        <div className="container">
          {loading3 ? (
            <Spinner />
          ) : article3 && article3.translations ? (
            <>
              <h1>{article3.translations[0].title}</h1>
              <div dangerouslySetInnerHTML={{ __html: article3.translations[0].body }} />
            </>
          ) : null}
        </div>
      </div>

      <div className="container container--vertical-padding">
        <div className="contact-row">
          
          <div className="rounded-card">
            
            {loading1 ? (
              <Spinner />
            ) : article1 && article1.translations ? (
              <>
                <h3>{article1.translations[0].title}</h3>
                <div dangerouslySetInnerHTML={{ __html: article1.translations[0].body }} />
              </>
            ) : null}
          </div>

          <div className="rounded-card">
            {loading2 ? (
              <Spinner />
            ) : article2 && article2.translations ? (
              <>
                <h3>{article2.translations[0].title}</h3>
                <div dangerouslySetInnerHTML={{ __html: article2.translations[0].body }} />
              </>
            ) : null}
          </div>
          
          <ChatButtons />
        </div>

        {/* <GridContainer>
          <Categories.Loop>
            <GridItem>
              <CategoryCard data-testid="category-card" />
            </GridItem>
          </Categories.Loop>
        </GridContainer> */}

        <div className="cards-grid">
          <a className="category-card icon icon-saxo-s" href="/da/categories/2-saxo-medlemskab">
            <h2>Saxo Medlemskab</h2>
            <p>Saxo.com tilbyder et attraktivt medlemskab. Læs mere her</p>
          </a>

          <a className="category-card icon icon-profile" href="/da/categories/6-saxo-profil">
            <h2>Saxo Profil</h2>
            <p>Se hvordan du ændrer dit kodeordet eller ændrer dine oplysninger</p>
          </a>

          <a className="category-card icon icon-app" href="/da/categories/3-saxo-app">
            <h2>Saxo App</h2>
            <p>Læs om brugen af Saxos app, til både købte samt streamede bøger</p>
          </a>

          <a className="category-card icon icon-phone" href="/da/categories/5-e-boger">
            <h2>E-bøger</h2>
            <p>Hvordan du læser dine e-bøger, og information om disse</p>
          </a>

          <a className="category-card icon icon-headphones" href="/da/categories/4-lydboger">
            <h2>Lydbøger</h2>
            <p>Information om lydbøger og hjælp til disse</p>
          </a>

          <a className="category-card icon icon-basket" href="/da/categories/7-kob-bestilling">
            <h2>Køb og Bestilling</h2>
            <p>Få et overblik over dine nuværende og tidligere bestillinger</p>
          </a>

          <a className="category-card icon icon-credit-card" href="/da/categories/8-betaling-gavekort">
            <h2>Betaling og Gavekort</h2>
            <p>Praktiske informationer om betaling og køb af gavekort hos Saxo.com</p>
          </a>

          <a className="category-card icon icon-delivery" href="/da/categories/9-levering">
            <h2>Levering</h2>
            <p>Praktisk information vedrørende levering af din ordre</p>
          </a>

          <a className="category-card icon icon-back" href="/da/categories/10-retur-reklamation">
            <h2>Retur og Reklamation</h2>
            <p>Læs mere om vores retur- og reklamationsmuligheder</p>
          </a>

          <a className="category-card icon icon-profession" href="/da/categories/13-erhverv">
            <h2>Erhverv</h2>
            <p>Spørgsmål til Faktura, EAN eller din virksomhedsprofil</p>
          </a>

          <a className="category-card icon icon-terms" href="/da/categories/11-vilkar-datapolitik">
            <h2 className="card-title">Vilkår og datapolitik</h2>
            <p className="card-info">Læs om vilkår og betingelser ved handel med Saxo.com</p>
          </a>

          <a className="category-card icon icon-diverse" href="/da/categories/12-diverse">
            <h2>Diverse</h2>
            <p>Her finder du svar på de spørgsmål, der ikke falder indenfor de andre kategorier</p>
          </a>
        </div>
      </div>
    </PageLayout>
  );
};
export default HomePage;